var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.621338,
    y: 0.798462,
    width: 28.6871,
    height: 28.6871,
    fill: "url(#pattern0_39_199)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0_39_199",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_39_199",
    transform: "scale(0.0111111)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_39_199",
    width: 90,
    height: 90,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFoAAABaCAYAAAA4qEECAAAAAXNSR0IArs4c6QAAAstJREFUeF7t27Fu01AYxfFzcQUkSgUSr8DEihrExsqARJmQYGACBgZGFl4ABpC6UIHUF0BiBDZW+gy8AiBBoSDFXORQW3FiF0e+OUv+ma17kl9PP9/cukG8LALBkkKIgDaVAGigTQKmGBoNtEnAFEOjgTYJmGJoNNAmAVMMjQbaJGCKodFAmwRMMTQaaJOAKYZGA20SMMXQaKBNAqYYGg20ScAUQ6OBNgmYYmg00CYBUwyNPoKOujxQNnkuhVuSDhW0p8mXx0Gffqf4WQBdQmdbu1K4W0cNb5V/3k6BDbSkKAVl42+SRovtTYMNdNXoKfRm85jojw10Cb2x9UwxPGyfx/2wga5uhudPKTv3RopXV4EN9Ixq1IWTykavJV07ZqfxXvnwetCHX8vsRoCe01oVNtANtVwFNtAtv/+psYE+ZtCmxAb6P3e0VNhAd9g6pMAGugN0cUlfbKA7QvfFrkFHXRwq23gqxeKo8MwS74FLawLF1/XBjdkvNXXobPxC0j3UUgiElyH/WB27VtBROqFsfCBpkCKGNfRT+f5mkP4UFkCvrhHN0NNhz+hIyb4b8v375YJzN8Pi72b5E0m3JZ1Nmbpma71TPtxuvRmuGcbSH7fPXpp9dEfuPsi1m2HHvLW8rC8y0B1qkwIZaNPJHdCms2igW6BTjYvZ5dl1zGGvAplGm5CBnoGO6voATf34s8PGZXoJo+NIKmbjHUkP2uEWz5i7IgNdIv87Iv4uadiM1w8Z6Dr0D0mnF6H7PdxYrsfoqEbHpT0p3qlDp0Gm0bWb4ZWRssMdKd6UNFGIrzT5+ijF0/5ANwzk4un/MP0ngLQvRkdaz9bVgAbaJGCKodFAmwRMMTQaaJOAKYZGA20SMMXQaKBNAqYYGg20ScAUQ6OBNgmYYmg00CYBUwyNBtokYIqh0UCbBEwxNBpok4AphkYDbRIwxdBoE/RfocftWzff9MsAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/Arrow.45dd5f86cd6da6ec4340abdd35b408bc.svg";
export { ForwardRef as ReactComponent };